import { Injectable } from '@angular/core';

import { Subject } from "rxjs";

@Injectable()
export class MenuService {
  redirecionarPara: Subject<any> = new Subject();
  redirecionarParaSub: Subject<any> = new Subject();

  constructor() {
  }

  redirecionarPagina(idSecaoPagina) {    
    this.redirecionarPara.next(idSecaoPagina);
  }

  redirecionarSubPagina(idSecaoPagina, analise) {
    let params = {
      idSecaoPagina: idSecaoPagina,
      analise: analise
    };
    this.redirecionarParaSub.next(params);
  }
}



// WEBPACK FOOTER //
// ./src/providers/menu-service.ts